var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18475 45.4538H38.2002C40.8051 45.4538 42.9167 43.2105 42.9167 40.4433V5.36906C42.9167 2.60178 40.8051 0.358459 38.2002 0.358459H5.18475C2.57991 0.358459 0.468262 2.60178 0.468262 5.36906V40.4433C0.468262 43.2105 2.57991 45.4538 5.18475 45.4538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.021 39.1906H30.7219V27.7928C30.7219 24.6679 29.6042 22.9215 27.2759 22.9215C24.7431 22.9215 23.4198 24.7389 23.4198 27.7928V39.1906H17.3493V17.478H23.4198V20.4027C23.4198 20.4027 25.2451 16.8147 29.5822 16.8147C33.9173 16.8147 37.021 19.627 37.021 25.4435V39.1906ZM10.1071 14.6349C8.03934 14.6349 6.36377 12.8409 6.36377 10.6283C6.36377 8.41573 8.03934 6.62171 10.1071 6.62171C12.1749 6.62171 13.8494 8.41573 13.8494 10.6283C13.8494 12.8409 12.1749 14.6349 10.1071 14.6349ZM6.97252 39.1906H13.3026V17.478H6.97252V39.1906Z",
    fill: "#122441"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.4484,
    height: 45.0954,
    fill: "white",
    transform: "translate(0.468262 0.358459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linkedIn_logo.4ed12bb80e944485420ca1c5485d48c7.svg";
export { ForwardRef as ReactComponent };